import React from 'react';
import { isInRoute } from 'utils/helpers';
import { IconLogout } from 'components';
import { useAuth } from 'context/authContext';
import { useUser } from 'context/userContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DefaultAvatar from 'assets/images/default-avatar.png';
import Logo from 'assets/images/logo.svg';
import LogoClean from 'assets/images/pf25-logo-clean.png';

export const ClientHeader = () => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { userDetails } = useUser();

  const avatarUrl = userDetails?.profile?.avatar || userDetails?.avatar;

  return (
    <div className="flex justify-between items-center px-10 md:px-4 py-4 md:py-3 shadow-block-shadow rounded-block-radius-sm md:rounded-2xl bg-white">
      {/* Signature Logo on Web (desktop) */}
      <img
        onClick={() => navigate('/dashboard')}
        className="w-32 cursor-pointer flex md:hidden"
        src={Logo}
        alt="pw25 logo"
      />
      {/* Clean Logo on Mobile */}
      <img
        onClick={() => navigate('/dashboard')}
        className="w-28 object-contain cursor-pointer hidden md:flex flex-shrink-0"
        src={LogoClean}
        alt="pw25 logo"
      />
      <div className="flex justify-between items-center min-w-0">
        {/* DESKTOP PROFILE CHIP (Name first, Avatar second) */}
        <Link
          to="/me"
          className={`flex md:hidden items-center p-2 pl-4 mr-4 rounded-[40px] transition-colors ${isInRoute(location.pathname, '/me') ? 'bg-yellow' : ''}`}
        >
          <div className="flex flex-col mr-3 min-w-0">
            <p className="text-black text-14 font-medium">
              {userDetails?.profile?.firstname} {userDetails?.profile?.lastname}
            </p>
          </div>
          <img
            className="w-[42px] h-[42px] rounded-full object-cover flex-shrink-0"
            src={avatarUrl || DefaultAvatar}
            alt="profile"
          />
        </Link>

        {/* MOBILE PROFILE CHIP (Name first, Avatar second, truncated name) */}
        <Link
          to="/me"
          className={`hidden md:flex items-center p-1.5 pl-3 mr-2 rounded-[40px] transition-colors ${isInRoute(location.pathname, '/me') ? 'bg-yellow' : ''}`}
        >
          <div className="flex flex-col mr-2 min-w-0">
            <p className="text-black text-12 font-medium truncate max-w-[100px]">
              {userDetails?.profile?.firstname} {userDetails?.profile?.lastname}
            </p>
          </div>
          <img
            className="w-[32px] h-[32px] rounded-full object-cover flex-shrink-0"
            src={avatarUrl || DefaultAvatar}
            alt="profile"
          />
        </Link>
        <IconLogout className="cursor-pointer flex-shrink-0" onClick={logout} />
      </div>
    </div>
  );
};
